export function getYearsRegistered(regDate: string): number {
  const [y, m, d] = regDate.split('-').map(Number);
  if (!y || !m || !d) return 0;
  const reg = new Date(y, m - 1, d);
  const now = new Date();
  let years = now.getFullYear() - reg.getFullYear();
  if (
    now.getMonth() < reg.getMonth() ||
    (now.getMonth() === reg.getMonth() && now.getDate() < reg.getDate())
  ) {
    years--;
  }
  return Math.max(0, years);
}
